/**
 * Layout component 
 */

import React from "react"
import PropTypes from "prop-types"

import CMMCHeader from "../cmmcheader"
import Footer from "../footer"
import CMMCSEO from "../cmmcseo"

import styles from "./cmmclayout.module.css"
/*import "./itmodlayout.css"*/

const Layout = ({ children }) => {

  return (
    <>
      <CMMCSEO title="Home" />
      <CMMCHeader />
      <div className={`container ${styles.container}`}>
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout